import { render, staticRenderFns } from "./ticketDetail.vue?vue&type=template&id=cc10dfd2&scoped=true&"
import script from "./ticketDetail.vue?vue&type=script&lang=js&"
export * from "./ticketDetail.vue?vue&type=script&lang=js&"
import style0 from "./ticketDetail.vue?vue&type=style&index=0&id=cc10dfd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc10dfd2",
  null
  
)

export default component.exports